import PropTypes from 'prop-types';
import { useCallback } from 'react';
import styled, { css } from 'styled-components';
import { Form } from 'react-bootstrap';

import { theme } from '_constants/theme';
import { ICONS_ALIASES } from '_constants/icons';
import { hexToRGBA } from '_helpers/theme';
import Icon from '_components/atomic/Icon';

const { colors, fontSizes, spaces } = theme;

const StyledGroup = styled(Form.Group)`
  padding-top: ${spaces.regular}px;
  padding-bottom: ${spaces.regular}px;
  border-top: 1px solid ${colors.gray[200]};
`;

const StyledLabel = styled(Form.Label)`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  margin-bottom: 0;

  font-family: 'Aeonik';
  font-size: ${fontSizes.regular}px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: ${colors.gray[800]};

  cursor: pointer;
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: ${spaces.medium}px;
  width: ${spaces.medium}px;
  min-height: ${spaces.medium}px;
  min-width: ${spaces.medium}px;

  margin-right: ${spaces.small - 2}px;

  background: ${colors.white};
  border: 1px solid ${colors.gray[500]};
  border-radius: 4px;

  ${({ active }) =>
    active &&
    css`
      border: 1px solid ${hexToRGBA(theme.colors.indigo[500], 0.4)};
      background: ${hexToRGBA(theme.colors.indigo[500], 0.4)};
    `}
`;

const Checkbox = ({
  name,
  label = 'Label',
  value = false,
  onChange,
  ...restProps
}) => {
  const handleChange = useCallback(
    (e) => {
      const { name, checked } = e.target;
      onChange && onChange({ target: { name, value: checked } });
    },
    [onChange]
  );

  return (
    <StyledGroup>
      <StyledLabel htmlFor={name}>
        <Form.Check
          {...restProps}
          hidden
          id={name}
          type="checkbox"
          name={name}
          checked={value}
          onChange={handleChange}
        />
        <StyledIconContainer active={value}>
          {value && (
            <Icon
              alias={ICONS_ALIASES.tick}
              color={colors.indigo[500]}
              width={10}
            />
          )}
        </StyledIconContainer>
        {label}
      </StyledLabel>
    </StyledGroup>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.node,
  value: PropTypes.bool,
  onChange: PropTypes.func,
};

export default Checkbox;
